import React, { Component } from "react";
import {
  Backdrop,
  Button,
  Container,
  Select,
  InputLabel,
  Fade,
  FormControl,
  Grid,
  // Modal,
  Paper,
  Snackbar,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  FormControlLabel,
} from "@material-ui/core";
import "../../App.css";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  // Table,
  Row,
  Col,
  UncontrolledAlert,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
} from "reactstrap";

import Modal from "react-awesome-modal";
import renderHTML from "react-render-html";
import { Link } from "react-router-dom";
import axios from "axios";
import Constants from "../Variables/Constants";
import init from "../../helpers/WindowToken";
import { lastPageRecordCount } from "./Components/PaginationTool";
import "../../App.css";
// import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core";

const classes = makeStyles();

export default class Orders extends Component {
  state = {
    allProducts: [],
    search: "",
    title: "",
    sequence: "",
    created_by: "",
    name: "",
    ordStatus: "",
    limit: 10,
    page: 1,
    nextPage: null,
    prevPage: null,
    totalDocs: 0,
    totalPages: 1,

    rowId: "",
    visible: false,
    loading: false,
    delMsg: "",
    delLoading: false,
    deleteSuccess: false,
    deleteMessage: "",
  };

  componentDidMount() {
    this.getAllOrders();
    window.addEventListener("newOrderNotification", this.getAllOrders);
  }

  componentWillUnmount() {
    window.removeEventListener("newOrderNotification", this.getAllOrders);
  }

  buildOrderListUrl = (pageOverride) => {
    const page = pageOverride || this.state.page;
    const query = new URLSearchParams({
      is_delete: "no",
      limit: this.state.limit,
      page,
    });

    if (this.state.ordStatus) {
      query.append("order_status", this.state.ordStatus);
    }

    if (this.state.search.trim()) {
      query.append("search", this.state.search.trim());
    }

    return `${Constants.getUrls.getAllOrders}?${query.toString()}`;
  };

  getAllOrders = () => {
    //   if ( init() === "success" ){
    axios
      .get(this.buildOrderListUrl())
      .then((resp) => {
        console.log(resp);
        this.setState({
          allProducts: resp.data.data.docs,
          limit: resp.data.data.limit,
          nextPage: resp.data.data.nextPage,
          page: resp.data.data.page,
          prevPage: resp.data.data.prevPage,
          totalDocs: resp.data.data.totalDocs,
          totalPages: resp.data.data.totalPages,
          // loading: true
        });
      });
    //   }
  };

  handleSelect = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
        page: 1,
      },
      () => {
        if (init() === "success") {
          this.getAllOrders();
        }
      }
    );
  };

  handleNext = () => {
    if (init() === "success") {
      axios
        .get(this.buildOrderListUrl(this.state.page + 1))

        .then((resp) => {
          this.setState({
            allProducts: resp.data.data.docs,
            limit: resp.data.data.limit,
            nextPage: resp.data.data.nextPage,
            page: resp.data.data.page,
            prevPage: resp.data.data.prevPage,
            totalDocs: resp.data.data.totalDocs,
            totalPages: resp.data.data.totalPages,
          });
        });
    }
  };

  handlePrev = () => {
    if (this.state.page > 1) {
      if (init() === "success") {
        axios
          .get(this.buildOrderListUrl(this.state.page - 1))
          .then((resp) => {
            this.setState({
              allProducts: resp.data.data.docs,
              limit: resp.data.data.limit,
              nextPage: resp.data.data.nextPage,
              page: resp.data.data.page,
              prevPage: resp.data.data.prevPage,
              totalDocs: resp.data.data.totalDocs,
              totalPages: resp.data.data.totalPages,
            });
          });
      }
    }
  };

  handleChange = (event, value) => {
    this.setState(
      {
        page: value,
      },
      () => {
        this.getAllOrders();
      }
    );
  };
  // search ends

  // delete starts
  handleModal = (category) => {
    this.setState({
      visible: true,
      rowId: category?._id,
      deleteMessage: `Delete order #${category?.order_date_id || category?._id}?`,
    });
  };

  handleDelete = () => {
    this.setState({
      delLoading: true,
    });
    if (init() === "success") {
      axios
        .delete(`${Constants.deleteUrls.deleteOrder}${this.state.rowId}`)
        .then((res) => {
          this.setState({
            deleteSuccess: true,
            delLoading: false,
            delMsg: res.data.message,
          });
          setTimeout(() => {
            this.setState({ deleteSuccess: false, visible: false }, () => {
              this.getAllOrders();
            });
          }, 2000);
        })
        .catch((error) => {
          this.setState({
            delLoading: false,
            visible: false,
            message: error?.response?.data?.message || "Failed to delete order",
            notification: true,
          });
        });
    } else {
      this.setState({ delLoading: false, visible: false });
    }
  };

  handleStatus = (contest, contestID) => {
    if (init() === "success") {
      let statusLoad = {
        status: contest,
      };
      // console.log(contest)
      axios
        .put(Constants.putUrls.productStatus + contestID, statusLoad)
        .then((resp) => {
          this.setState({
            status: true,
          });
          setTimeout(() => {
            this.setState({ status: false }, () => {
              this.getAllOrders();
            });
          }, 1000);
        });
    }
  };

  generateQR = (id) => {
    axios
      .get(Constants.getUrls.generateOrderQr + "/" + id)
      .then((resp) => {
        this.setState({
          message: "QR Generated successfully!",
          notification: true,
        });
        setTimeout(() => {
          this.setState({ message: "", notification: false }, () =>
            this.getAllOrders()
          );
        }, 2500);
      })
      .catch((err) => {
        this.setState({
          message: "Something went wrong!!!",
          notification: true,
        });
        setTimeout(() => {
          this.setState({ message: "", notification: false }, () =>
            this.getAllOrders()
          );
        }, 2500);
      });
  };

  handleSearch = () => {
    axios
      .get(this.buildOrderListUrl(1))
      .then((resp) => {
        this.setState({
          allProducts: resp.data.data.docs,
          limit: resp.data.data.limit,
          nextPage: resp.data.data.nextPage,
          page: resp.data.data.page,
          prevPage: resp.data.data.prevPage,
          totalDocs: resp.data.data.totalDocs,
          totalPages: resp.data.data.totalPages,
          // loading: true
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handlePicked = (id) => {
    axios
      .put(Constants.putUrls.orderPicked + "/" + id)
      .then((resp) => {
        this.setState({
          message: "Order Picked successfully!",
          notification: true,
        });
        setTimeout(() => {
          this.setState({ message: "", notification: false }, () =>
            this.getAllOrders()
          );
        }, 2500);
      })
      .catch((err) => {
        this.setState({
          message: "Something went wrong!!!",
          notification: true,
        });
        setTimeout(() => {
          this.setState({ message: "", notification: false }, () =>
            this.getAllOrders()
          );
        }, 2500);
      });
  };

  render() {
    return (
      <div>
        <Container maxWidth="xl">
          <Grid container spcaing={2}>
            <Grid item sm={6}>
              <Typography variant="h4">Orders</Typography>
            </Grid>
            {this.state.notification ? (
              <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                open={true}
                color={"s"}
                autoHideDuration={6000}
                message={this.state.message}
              ></Snackbar>
            ) : null}
            <Grid container>
              <FormControl style={{ marginBottom: "2rem" }}>
                <TextField
                  id="standard-basic"
                  label="Search..."
                  placeholder="Readable order ID, name, mobile, order date"
                  variant="standard"
                  size="small"
                  name="search"
                  style={{ width: "300px" }}
                  onChange={(e) => {
                    this.setState(
                      {
                        search: e.target.value,
                        page: 1,
                      },
                      () => {
                        this.handleSearch();
                      }
                    );
                  }}
                />
              </FormControl>

              {/* Order Status Filter */}
              <Grid sm={4} style={{ marginLeft: "60px" }}>
                <FormControl
                  // style={{ marginTop: "12px" }}
                  fullWidth
                  className={classes.selectFormControl}
                >
                  <InputLabel
                    style={{
                      marginLeft: "15px",
                    }}
                    htmlFor="simple-select"
                    className={classes.selectLabel}
                  >
                    Search By Status
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    classes={{
                      select: classes.select,
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    value={this.state.ordStatus}
                    inputProps={{
                      name: "ordStatus",
                      id: "simple-select",
                      onChange: (e) => {
                        this.setState(
                          {
                            ordStatus: e.target.value,
                          },
                          () => {
                            this.setState({ page: 1 }, () => {
                              this.getAllOrders();
                            });
                          }
                        );
                      },
                      required: true,
                    }}
                  >
                    <MenuItem value="order_placed">Order Placed</MenuItem>
                    <MenuItem value="order_picked"> Order Picked</MenuItem>
                    <MenuItem value="order_returned">Order Returned</MenuItem>
                    <MenuItem value="order_returned_late">
                      Order Return Late
                    </MenuItem>
                    <MenuItem value="order_cancelled">Order Cancelled</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid sm={12}>
            <Paper elevetion={1}>
              <TableContainer>
                <Table size="small" stickyHeader aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>S.No</TableCell>
                      <TableCell>Order ID</TableCell>
                      <TableCell>User Name</TableCell>
                      <TableCell align="center"> Product Name </TableCell>
                      <TableCell align="center"> Product Image </TableCell>
                      <TableCell align="center"> Order Status</TableCell>
                      <TableCell align="center"> Mobile </TableCell>
                      <TableCell align="center"> Price </TableCell>
                      <TableCell align="center"> Order Date </TableCell>
                      <TableCell align="center"> Order Details</TableCell>
                      {/* <TableCell align="center"> Order Picked</TableCell> */}
                      <TableCell align="center"> Actions </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {this.state.allProducts?.length > 0 ? (
                      this.state.allProducts.map((sec, index) => (
                        <TableRow>
                          <TableCell>
                            {" "}
                            {Number((this.state.page - 1) * this.state.limit) +
                              Number(index + 1)}{" "}
                          </TableCell>
                          <TableCell> {sec?.order_date_id || sec?._id} </TableCell>
                          <TableCell> {sec?.user_name} </TableCell>
                          <TableCell align="center">
                            {" "}
                            {sec.product_name}
                            {/* {sec.product.length > 0 &&
                              sec.product.map((item) => item.name + ", ")} */}
                          </TableCell>
                          <TableCell align="center">
                            {sec.cart_id.map((item, index) => {
                              const image =
                                item?.variant_id?.images?.[0] ||
                                item?.product_id?.images?.[0];

                              return (
                                <img
                                  key={index}
                                  height={60}
                                  src={image ? `${Constants.imgDomain}${image}` : ""}
                                  alt="Product Image"
                                />
                              );
                            })}
                          </TableCell>
                          <TableCell align="center">
                            {" "}
                            {sec.order_status.toUpperCase()}{" "}
                          </TableCell>
                          <TableCell align="center">
                            {" "}
                            {sec?.mobile_no}
                          </TableCell>
                          <TableCell align="center">
                            {" "}
                            {sec?.order_amount}
                          </TableCell>
                          <TableCell align="center">
                            {" "}
                            {sec?.order_date}
                          </TableCell>
                          <TableCell align="center">
                            <Link
                              to={{
                                pathname: "/admin/orderDetails/" + sec._id,
                              }}
                            >
                              <Button
                                variant="outlined"
                                size="small"
                                color="secondary"
                              >
                                {" "}
                                Details
                              </Button>
                            </Link>
                          </TableCell>
                          {/* <TableCell align="center">
                            {sec.order_status === "order_placed" ? (
                              <Button
                                variant="outlined"
                                size="small"
                                color="secondary"
                                onClick={() => {
                                  this.handlePicked(sec._id);
                                }}
                              >
                                {" "}
                                Pick Order
                              </Button>
                            ) : (
                              <Button
                                variant="outlined"
                                size="small"
                                color="primary"
                              >
                                {" "}
                                {sec.order_status}
                              </Button>
                            )}
                          </TableCell> */}
                          <TableCell>
                            {sec.qr_code == "" ||
                            sec.qr_code == undefined ||
                            sec.qr_code == null ? (
                              <Button
                                onClick={() => {
                                  this.generateQR(sec._id);
                                }}
                                variant="contained"
                                size="small"
                                color="primary"
                              >
                                {" "}
                                Generate QR
                              </Button>
                            ) : (
                              <a
                                href={"https://core.mfd.co.in" + sec.qr_code}
                                target="_blank"
                              >
                                <Button
                                  variant="contained"
                                  size="small"
                                  color="success"
                                  style={{
                                    backgroundColor: "#A6FF96",
                                  }}
                                >
                                  {" "}
                                  Scan QR
                                </Button>
                              </a>
                            )}
                            <Button
                              onClick={() => this.handleModal(sec)}
                              variant="outlined"
                              size="small"
                              color="secondary"
                              style={{ marginLeft: "8px" }}
                            >
                              Delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell>NO DATA FOUND</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>

                <TableRow
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <div>
                    <p>
                      {Number((this.state.page - 1) * this.state.limit) + 1} to{" "}
                      {lastPageRecordCount(
                        this.state.totalDocs,
                        this.state.page,
                        this.state.limit
                      )}{" "}
                      of {this.state.totalDocs} Entries
                    </p>
                  </div>

                  {/* Rows PerPage START */}

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "200px",
                    }}
                  >
                    <p>Rows Per Page</p>

                    <FormControl
                      className="selectMerchants"
                      style={{ marginRight: "20px", marginTop: "-12px" }}
                    >
                      <InputLabel htmlFor="age-native-simple"></InputLabel>
                      <Select
                        native
                        value={this.state.limit}
                        onChange={this.handleSelect}
                        inputProps={{
                          name: "limit",
                          id: "age-native-simple",
                        }}
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </Select>
                    </FormControl>
                  </div>

                  {/* Rows PerPage END */}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginLeft: "290px",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="secondary"
                      className="mx-5"
                      style={{ margin: "10px" }}
                      disabled={this.state.prevPage === null}
                      onClick={this.handlePrev}
                      // Hidden
                    >
                      Previous
                    </Button>{" "}
                    <Pagination
                      count={this.state.totalPages}
                      shape="rounded"
                      page={this.state.page}
                      onChange={this.handleChange}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      className="mx-5"
                      disabled={this.state.nextPage === null}
                      style={{ margin: "10px" }}
                      onClick={this.handleNext}
                    >
                      Next
                    </Button>
                  </div>
                </TableRow>
              </TableContainer>
            </Paper>
          </Grid>

          <Modal
            visible={this.state.visible}
            onClickAway={() => this.setState({ visible: false })}
            width="500px"
            height="230px"
            effect="fadeInUp"
          >
            <Row>
              <Col xs={12} xm={12} md={12}>
                <Card>
                  <CardBody>
                    <div className="modal">
                      <h3
                        className="changeColor"
                        style={{ color: "black", marginLeft: "13px" }}
                      >
                        {" "}
                        {this.state.deleteMessage}
                      </h3>

                      {this.state.deleteSuccess ? (
                        <Snackbar
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "bottom",
                          }}
                          open={true}
                          autoHideDuration={5000}
                          color={"s"}
                          message="deleted Successfully"
                        ></Snackbar>
                      ) : null}

                      <Row>
                        <Col xs={12} xm={12} md={4}>
                          <br />
                          <Button
                            className=""
                            color="secondary"
                            variant="contained"
                            style={{ margin: "10px" }}
                            onClick={() => {
                              this.handleDelete(this.state.rowId);
                            }}
                            disabled={this.state.delLoading}
                          >
                            {this.state.delLoading ? "Deleting..." : "Yes"}
                          </Button>
                          <Button
                            className=""
                            variant="contained"
                            color="primary"
                            style={{ margin: "10px", marginLeft: "4px" }}
                            onClick={() => {
                              this.setState({ visible: false });
                            }}
                          >
                            no
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Modal>
        </Container>
      </div>
    );
  }
}
